import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from '../components/login/Login';
import Dashboard from '../components/dashboard/Dashboard';
import PujaService from '../components/puja-service';
import AddPuja from '../components/puja-service/addPuja';
import PrivateRoute from './PrivateRoute';
import PujaTag from '../components/tag';
import AddTag from '../components/tag/addTag';
import Users from '../components/users';
import AddUser from '../components/users/AddUser';
import PujaCalendar from '../components/users/PujaCalendar';
import Bookings from '../components/bookings';
import AddBooking from '../components/bookings/AddBooking';
import AddPastBooking from '../components/bookings/AddPastBooking';
import Payments from '../components/payments';
import PaymentAudit from '../components/payments/PaymentAudit';
import NotFound from '../components/not-found/NotFound';
import AccessControl from '../components/accessControl/accessControl';
import AccessDenied from '../components/access-denied/AccessDenied';
import Task from '../components/task/task';
import Refund from '../components/refund';
import PromotionSegment from '../components/promotionSegment';
import AddSegment from '../components/promotionSegment/addSegment';
import PromoCodeList from '../components/promocode';
import AddPromocode from '../components/promocode/addPromocode';
import CampaignListing from '../components/campaign';
import AddCampaign from '../components/campaign/addCampaign';
import Testimonials from '../components/testimonials';
import AddTestimonial from '../components/testimonials/addTestimonial';
import GeoPrice from '../components/geo-price';
import FestivalCampaignList from '../components/festival-campaign';
import AddFestivalCampaign from '../components/festival-campaign/addFestivalCampaign';
import FestivalPujas from '../components/festival-pujas';
import PanditVerification from '../components/pandit-verification';
import PanditDetail from '../components/pandit-verification/PanditDetail';
import AllocationDashboard from '../components/allocation/AllocationDashboard';
import Dakshinas from '../components/dakshinas';
import PujaControl from '../components/puja-control';
import BannerList from '../components/banner';

const AppRoutes = () => {
  return (
    <Routes>
      {/* <PrivateRoute path="/" element={<Dashboard />} /> */}

      <Route path="/login" element={<Login />} />
      <Route path="/" element={<PrivateRoute Component={Dashboard} requiredPrivilege="dashboard" />} />
      <Route path="/service" element={<PrivateRoute Component={PujaService} requiredPrivilege="puja_service" />} />
      <Route path="/add-puja" element={<PrivateRoute Component={AddPuja} requiredPrivilege="puja_service" />} />
      <Route path="/edit-puja/:id" element={<PrivateRoute Component={AddPuja} requiredPrivilege="puja_service" />} />
      <Route path="/tag" element={<PrivateRoute Component={PujaTag} requiredPrivilege="puja_category" />} />
      <Route path="/add-tag" element={<PrivateRoute Component={AddTag} requiredPrivilege="puja_category" />} />
      <Route path="/edit-tag/:id" element={<PrivateRoute Component={AddTag} requiredPrivilege="puja_category" />} />
      <Route path="/users" element={<PrivateRoute Component={Users} requiredPrivilege="user" />} />
      <Route path="/add-user" element={<PrivateRoute Component={AddUser} requiredPrivilege="user" />} />
      <Route path="/edit-user/:id" element={<PrivateRoute Component={AddUser} requiredPrivilege="user" />} />
      <Route path="/puja-calendar/:userId" element={<PrivateRoute Component={PujaCalendar} requiredPrivilege="user" />} />
      <Route path="/booking" element={<PrivateRoute Component={Bookings} requiredPrivilege="booking" />} />
      <Route path="/edit-booking/:id" element={<PrivateRoute Component={AddBooking} requiredPrivilege="booking" />} />
      <Route path="/add-booking/" element={<PrivateRoute Component={AddBooking} requiredPrivilege="booking" />} />
      <Route path="/add-past-booking/" element={<PrivateRoute Component={AddPastBooking} requiredPrivilege="booking" />} />
      <Route path="/payments/" element={<PrivateRoute Component={Payments} requiredPrivilege="booking" />} />
      <Route path="/audit-payment/:bookingId" element={<PrivateRoute Component={PaymentAudit} requiredPrivilege="booking" />} />
      <Route path="/access-control/" element={<PrivateRoute Component={AccessControl} requiredPrivilege="access_control" />} />
      <Route path="/task/" element={<PrivateRoute Component={Task} requiredPrivilege="task" />} />
      <Route path="/refund/" element={<PrivateRoute Component={Refund} requiredPrivilege="task" />} />
      <Route path="/access-denied/" element={<AccessDenied />} />
      <Route path="/segment/" element={<PrivateRoute Component={PromotionSegment} requiredPrivilege="segment" />} />
      <Route path="/add-segment/" element={<PrivateRoute Component={AddSegment} requiredPrivilege="segment" />} />
      <Route path="/edit-segment/:id" element={<PrivateRoute Component={AddSegment} requiredPrivilege="segment" />} />
      <Route path="/promocode/" element={<PrivateRoute Component={PromoCodeList} requiredPrivilege="promo_code" />} />
      <Route path="/add-promocode/" element={<PrivateRoute Component={AddPromocode} requiredPrivilege="promo_code" />} />
      <Route path="/edit-promocode/:id" element={<PrivateRoute Component={AddPromocode} requiredPrivilege="promo_code" />} />
      <Route path="/campaign/" element={<PrivateRoute Component={CampaignListing} requiredPrivilege="campaign" />} />
      <Route path="/add-campaign/" element={<PrivateRoute Component={AddCampaign} requiredPrivilege="campaign" />} />
      <Route path="/edit-campaign/:id" element={<PrivateRoute Component={AddCampaign} requiredPrivilege="campaign" />} />
      {/* Testimonials routes */}
      <Route path="/geo-price" element={<PrivateRoute Component={GeoPrice} requiredPrivilege="puja_service" />} />
      <Route path="/testimonials" element={<PrivateRoute Component={Testimonials} requiredPrivilege="testimonial" />} />
      <Route path="/add-testimonial" element={<PrivateRoute Component={AddTestimonial} requiredPrivilege="testimonial" />} />
      <Route path="/edit-testimonial/:id" element={<PrivateRoute Component={AddTestimonial} requiredPrivilege="testimonial" />} />
      {/* Festival Puja Campaign routes */}
      <Route path="/festival-campaign" element={<PrivateRoute Component={FestivalCampaignList} requiredPrivilege="campaign" />} />
      <Route path="/add-festival-campaign" element={<PrivateRoute Component={AddFestivalCampaign} requiredPrivilege="campaign" />} />
      {/* Festival Puja Management */}
      <Route path="/festival-pujas" element={<PrivateRoute Component={FestivalPujas} requiredPrivilege="puja_category" />} />

      <Route path="/pandit-verification" element={<PrivateRoute Component={PanditVerification} requiredPrivilege="pandit_verification" />} />
      <Route path="/pandit-verification/:userId" element={<PrivateRoute Component={PanditDetail} requiredPrivilege="pandit_verification" />} />
      <Route path="/allocation-dashboard" element={<PrivateRoute Component={AllocationDashboard} requiredPrivilege="pandit_verification" />} />
      <Route path="/dakshinas" element={<PrivateRoute Component={Dakshinas} requiredPrivilege="pandit_verification" />} />
      <Route path="/puja-control" element={<PrivateRoute Component={PujaControl} requiredPrivilege="pandit_verification" />} />

      {/* Hero Banner routes */}
      <Route path="/banner" element={<PrivateRoute Component={BannerList} requiredPrivilege="campaign" />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AppRoutes;
